import React, {useState, useContext, useEffect} from 'react';
import {connect} from 'react-redux';
import {showAppLoader, hideAppLoader} from 'app/Components/Shared/Loader/LoaderSlice';
import {getOrdersList} from '../SimActivationProviders';
import SimInput, {SimInputChange} from './SimInput';
import SimActivationContext from 'app/Components/Page/SimActivationPage/SimActivationContext';
import {dwhPortingCodePageButtonClick, dwhPortingCodePageDisplayed} from '../reports/dwhReports';

function SimVerifyEnvelope(props) {
  const [{stage, phone, ticket}, dispatch] = useContext(SimActivationContext);
  const [input, setInput] = useState<SimInputChange>(null);

  useEffect(() => {
    if (stage == 'Envelope') {
      dwhPortingCodePageDisplayed({subscriber: phone ?? '', userDetails: props.userDetails});
    }
  }, []);

  async function onContinue() {
    dwhPortingCodePageButtonClick({subscriber: phone ?? '', userDetails: props.userDetails});
    if (input.valid) {
      props.showAppLoader();
      const subscriberNumber = phone;
      const verificationCode = input.value;
      const ticketId = ticket;
      const result = await getOrdersList({subscriberNumber, ticketId, verificationCode});
      dispatch({type: 'orders', result, verification: verificationCode});
      props.hideAppLoader();
    }
  }

  return (
    <div className='SimVerifyEnvelope'>
      <h1 className='SimActivationBlock__main__title'>הפעלת ניוד</h1>
      <h1 className='SimActivationBlock__top__title'>קיבלת קוד להפעלת הניוד</h1>
      <h2 className='SimActivationBlock__top__text'>SIM - הקוד מופיע על המדבקה</h2>
      {props.iContent?.esimData?.value && <h2 className='SimActivationBlock__top__text'>eSim - הקוד מופיע ב-SMS שקיבלתם</h2>}
      <SimInput digits={5} onChange={setInput} />
      <div className='SimActivationBlock__button'>
        <button className='btn-continue' onClick={onContinue}>
          אוקיי, אפשר להמשיך
        </button>
      </div>
    </div>
  );
}

const mapDispatchToProps = {
  showAppLoader,
  hideAppLoader,
};

const mapStateToProps = (state) => {
  return {
    userDetails: state.authentication?.loginData?.userDetails,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SimVerifyEnvelope);
